import { apiClient } from './client';

export interface ModulePricing {
  schoolYearId: number;
  schoolYearCode: string;
  price: number | null;
  priceT2: number | null;
  priceT3: number | null;
  priceT4: number | null;
}

export interface ModuleSchool {
  id: number;
  name: string;
  code: string;
  activationDate: string | null;
}

export interface Module {
  id: number;
  code: string;
  name: string;
  isV2: boolean;
  schoolCount: number;
  currentPrice: number | null;
  createdAt: string | null;
  updatedAt: string | null;
}

export interface ModuleDetail extends Module {
  pricing: ModulePricing[];
  schools: ModuleSchool[];
}

export interface SchoolYear {
  id: number;
  code: string;
  startingDate: string;
  endingDate: string;
  isCurrent: boolean;
}

export interface CreateModuleData {
  code: string;
  name: string;
  isV2?: boolean;
  pricing?: {
    schoolYearId: number;
    price?: number | null;
    priceT2?: number | null;
    priceT3?: number | null;
    priceT4?: number | null;
  }[];
}

export interface UpdateModuleData {
  name?: string;
  pricing?: {
    schoolYearId: number;
    price?: number | null;
    priceT2?: number | null;
    priceT3?: number | null;
    priceT4?: number | null;
  }[];
}

export const modulesApi = {
  async getAll(): Promise<Module[]> {
    const response = await apiClient.get<Module[]>('/api/modules');
    return response.data;
  },

  async getByCode(code: string): Promise<ModuleDetail> {
    const response = await apiClient.get<ModuleDetail>(`/api/modules/${code}`);
    return response.data;
  },

  async getSchoolYears(): Promise<SchoolYear[]> {
    const response = await apiClient.get<SchoolYear[]>('/api/modules/school-years');
    return response.data;
  },

  async create(data: CreateModuleData): Promise<Module> {
    const response = await apiClient.post<Module>('/api/modules', data);
    return response.data;
  },

  async update(code: string, data: UpdateModuleData): Promise<Module> {
    const response = await apiClient.put<Module>(`/api/modules/${code}`, data);
    return response.data;
  },

  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/modules/${code}`);
  },
};
